import styled from 'styled-components';
import { Colors } from '../../scss/common/style';
import arrowOrange from '../../static/img/arrowOrange.svg';
import arrowLineOrange from '../../static/img/arrowLineOrange.svg';
import arrowDownOrange from '../../static/img/arrowDownOrange.svg';
import filterIcon from '../../static/img/filterIcon.svg';
import xIcon from '../../static/img/xIcon.svg';

interface Props {
  children: React.ReactNode;
  textAlign?: string;
}

export default function GridWrapper({ children, textAlign = 'left' }: Props): JSX.Element {
  return <FormGridWrapper textAlign={textAlign}>{children}</FormGridWrapper>;
}

const FormGridWrapper = styled.div`
  .k-filtercell-wrapper {
    .k-dropdown-operator {
      background: #fff;
      border: #fff;
      .k-dropdown-wrap {
      }
    }
    .k-select {
      position: relative;
      background: #fff;
      border: #fff;
      background: url(${filterIcon}) no-repeat center !important;
    }
    .k-select:hover {
      filter: brightness(0.4) !important;
      opacity: 1 !important;
    }
    .k-select:focus {
      filter: brightness(0.4) !important;
      opacity: 1 !important;
    }
    .k-state-focused {
      filter: brightness(0.4) !important;
      opacity: 1 !important;
      border: none;
    }
    .k-textbox {
      height: 25px !important;
      padding: 0 !important;
      padding-left: 10px !important;
      border-color: #eeeeee !important;
      ::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      ::-webkit-outer-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }
      border: 1px solid #eeeeee;
      border-radius: 200px !important;
      &:active {
        box-shadow: none !important;
        border: 1px solid #eeeeee;
        border-color: #eeeeee !important;
      }
      &:hover {
        box-shadow: none !important;
        border: 1px solid #eeeeee;
        border-color: #eeeeee !important;
      }
      &:focus {
        box-shadow: none !important;
        border: 1px solid #eeeeee;
        border-color: #eeeeee !important;
      }
    }
  }
  .k-grid .k-grid-header,
  .k-grid .k-grid-toolbar {
    padding: 0;
  }
  .k-grid .k-grid-pager {
    background: #fff !important;
    display: flex;
    justify-content: right;
  }
  .k-grid-header {
    border: 0 !important;
  }
  .k-grid {
    border: 2px solid #fff !important;
  }
  .k-grid-header div:last-child {
    background-color: #fff !important;
    border: 1px solid #fff !important;
  }
  k-grid-header {
    border: 2px solid #fff !important;
  }
  .k-grid-header-wrap {
    div {
      border: 2px solid white;
    }
  }
  table {
    border-radius: 10px;
    overflow: hidden;
  }
  div {
  }
  th {
    border-right: 1px solid white;
    border-left: 1px solid #fff;
    border-bottom: none;
  }
  th.k-sorted {
    background-color: #fff !important;
  }
  td {
    min-height: 41px !important;
    height: 41px !important;
    border-right: 1px solid white;
    border-left: 1px solid white;
  }
  tr:nth-child(even) {
    background-color: #fbfbfb;
  }
  tr:nth-child(odd) {
    background-color: #f4f4f4;
  }
  thead tr {
    background-color: #fff !important;
    border: 2px solid #fff !important;
    th {
      padding: 0;
    }
  }
  tbody td {
    text-align: ${(props) => props.textAlign};
  }
  thead tr:nth-child(1) th {
    font-size: 15px;
    font-weight: 700;
    color: ${Colors.darkBrown};
    padding: 5px;
  }
  thead tr:nth-child(2) {
    th {
      display: 1;
      justify-content: flex-start;
      div {
        display: flex;
        justify-content: flex-start;
        padding: 0;
      }
    }
  }
  thead td {
    background-color: #fff !important;

    border-right: 2px solid white !important;
    border-left: 2px solid white !important;
  }
  .form-group {
    padding: 0;
    margin: 0;
  }
  .k-grid .k-filter-row .k-button.k-clear-button-visible,
  .k-grid .k-filter-row .k-button:focus.k-clear-button-visible {
    background: url(${xIcon}) no-repeat center !important;
  }

  .k-button-icon {
    background: transparent !important;
  }
  .k-pager-wrap {
    width: 100%;
    .k-dropdown {
      background: #fff !important;
      border-radius: 200px !important;
      min-width: 60px;
    }
    .k-popup {
      z-index: 10000 !important;
      background: #fff !important;
      min-width: 80px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    }
    .k-list-container {
      z-index: 10001 !important;
      background: #fff !important;
      min-width: 80px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.08);
    }
    .k-list-ul {
      min-width: 80px;
    }
    .k-list-item {
      white-space: nowrap;
      padding: 4px 12px;
      background: #fff;
      &:hover {
        background: #f4f4f4;
      }
    }
    .k-button-icon {
      background: transparent !important;
    }
    display: flex;
    color: #b4b4b4;
    .k-link {
      color: #b4b4b4 !important;
    }
    .k-state-selected {
      color: #343434 !important;
      background: transparent;
    }
    .k-i-arrow-60-left:before {
      display: none;
    }
    .k-i-arrow-60-left {
      position: relative;
    }
    .k-i-arrow-60-left:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background-image: url(${arrowOrange});
      background-size: contain;
      height: 15px;
      width: 15px;
      background-repeat: no-repeat;
    }
    .k-i-arrow-end-left {
      position: relative;
    }
    .k-i-arrow-end-left:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background-image: url(${arrowLineOrange});
      background-size: contain;
      height: 15px;
      width: 15px;
      background-repeat: no-repeat;
    }
    .k-i-arrow-end-left:before {
      display: none;
    }
    .k-i-arrow-60-right:before {
      display: none;
    }
    .k-i-arrow-60-right {
      position: relative;
    }
    .k-i-arrow-60-right:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background-image: url(${arrowOrange});
      background-size: contain;
      height: 15px;
      width: 15px;
      background-repeat: no-repeat;
      transform: rotateY(180deg);
    }
    .k-i-arrow-end-right {
      position: relative;
    }
    .k-i-arrow-end-right:after {
      content: '';
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      background-image: url(${arrowLineOrange});
      background-size: contain;
      height: 15px;
      width: 15px;
      background-repeat: no-repeat;
      transform: rotateY(180deg);
    }
    .k-i-arrow-end-right:before {
      display: none;
    }
    .k-i-arrow-s {
      position: relative;
    }
    .k-i-arrow-s:before {
      display: none;
    }
    .k-i-arrow-s:after {
      content: '';
      position: absolute;
      top: 6px;
      left: 0;
      right: 0;
      background-image: url(${arrowDownOrange});
      background-size: contain;
      height: 10px;
      width: 12px;
      background-repeat: no-repeat;
    }
    .k-i-arrow-s:after:hover {
      background: ${Colors.darkBrown}!important;
    }
    a:hover {
      background-color: transparent;
      color: ${Colors.darkBrown}!important;
      fill: ${Colors.darkBrown}!important;
    }
    .k-pager-info {
      position: static;
      left: 0;
    }
  }
  li {
    backround: red!mportant;
    color: red !important;
  }
`;
